<odx-tab-bar (selectedTabChanged)="selectedTabIndex.set($event.selectedIndex)">
  <odx-tab-bar-item i18n="@@floorplan.details.gasWarningCenter.tabBar.tab1">Schaltschrank</odx-tab-bar-item>
  <odx-tab-bar-item i18n="@@floorplan.details.gasWarningCenter.tabBar.tab2">Produkte</odx-tab-bar-item>
</odx-tab-bar>

@if (selectedTabIndex() === 0) {
  <div odxLayout="flex" class="flex-column wrapper">
    <h5 i18n="@@floorplan.details.gasWarningCenterCabinet.title" class="odx-title-5">Schaltschrank</h5>
    <form [formGroup]="editGasWarningCenterForm" odxForm [readonly]="gasWarningCenter().locked" odxLayout="grid 6">
      <div>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.maxHeight" label="Maximale Höhe">
          <input
            type="text"
            formControlName="maxHeight"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.maxHeight"
            placeholder="Maximale Höhe"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.maxWidth" label="Maximale Breite">
          <input
            type="text"
            formControlName="maxWidth"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.maxWidth"
            placeholder="Maximale Breite"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.maxDepth" label="Maximale Tiefe">
          <input
            type="text"
            formControlName="maxDepth"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.maxDepth"
            placeholder="Maximale Tiefe"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.material" label="Material">
          <input
            type="text"
            formControlName="material"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.material"
            placeholder="Material"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.doorstop" label="Türausrichtung">
          <odx-select
            formControlName="doorstop"
            odxFormFieldControl
            placeholder="Keine Auswahl"
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.doorstop.noSelection"
          >
            <odx-select-option [value]="DoorstopType.LEFT" i18n="@@editGasWarningCenterCabinetForm.label.doorstop.left">
              Links
            </odx-select-option>
            <odx-select-option [value]="DoorstopType.RIGHT" i18n="@@editGasWarningCenterCabinetForm.label.doorstop.right">
              Rechts
            </odx-select-option>
          </odx-select>
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.cableInlet" label="Kabeleingang">
          <odx-select
            formControlName="cableInlet"
            odxFormFieldControl
            placeholder="Keine Auswahl"
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.cableInlet.noSelection"
          >
            <odx-select-option [value]="CableInletType.TOP" i18n="@@editGasWarningCenterCabinetForm.label.cableInlet.top">
              Oben
            </odx-select-option>
            <odx-select-option [value]="CableInletType.BOTTOM" i18n="@@editGasWarningCenterCabinetForm.label.cableInlet.bottom">
              Unten
            </odx-select-option>
            <odx-select-option [value]="CableInletType.LEFT" i18n="@@editGasWarningCenterCabinetForm.label.cableInlet.left">
              Links
            </odx-select-option>
            <odx-select-option [value]="CableInletType.RIGHT" i18n="@@editGasWarningCenterCabinetForm.label.cableInlet.right">
              Rechts
            </odx-select-option>
          </odx-select>
        </odx-form-field>
        <odx-checkbox
          class="checkbox-padding"
          formControlName="outdoorInstallation"
          i18n="@@editGasWarningCenterCabinetForm.label.outdoorInstallation"
        >
          UV-geschützt/Außeninstallation
        </odx-checkbox>
      </div>
      <div>
        <odx-form-field
          i18n-label="@@editGasWarningCenterCabinetForm.label.minEnvironmentalTemperature"
          label="Mindestumgebungstemperatur"
        >
          <input
            type="text"
            formControlName="minEnvironmentalTemperature"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.minEnvironmentalTemperature"
            placeholder="Mindestumgebungstemperatur"
          />
        </odx-form-field>
        <odx-form-field
          i18n-label="@@editGasWarningCenterCabinetForm.label.maxEnvironmentalTemperature"
          label="Höchstumgebungstemperatur"
        >
          <input
            type="text"
            formControlName="maxEnvironmentalTemperature"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.maxEnvironmentalTemperature"
            placeholder="Höchstumgebungstemperatur"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.ipProtectionCategory" label="IP-Sicherheitskategorie">
          <input
            type="text"
            formControlName="ipProtectionCategory"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.ipProtectionCategory"
            placeholder="IP-Sicherheitskategorie"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@editGasWarningCenterCabinetForm.label.notes" label="Schaltschranknotizen">
          <textarea
            formControlName="notes"
            odxFormFieldControl
            i18n-placeholder="@@editGasWarningCenterCabinetForm.placeholder.notes"
            placeholder="Notizen"
            class="textarea-large"
          ></textarea>
          <ng-template odxFormFieldError>
            <ng-container i18n="@@editGasWarningCenterCabinetForm.notes.maxLengthExceeded"
              >Maximale Zeichenanzahl überschritten</ng-container
            >
          </ng-template>
        </odx-form-field>
      </div>
    </form>
  </div>
}
@if (selectedTabIndex() === 1) {
  <div odxLayout="6 grid">
    <app-floorplan-custom-part-numbers [floorplanItem]="gasWarningCenter()"></app-floorplan-custom-part-numbers>
  </div>
}
